<template>
  <fts-dropdown-select ref="filterDropdown" append-to-body content-class="filter-content" @show="onFilterModalShow">
    <template #toggle>
      <fts-btn 
        outline 
        text-transform-init 
        class="filter-action-button" 
        :class="{'filter-action-btn--active': filters.items.length}"
      >
        <span class="material-symbols-outlined filter-action-button-icon">filter_alt</span>
        <span>Filter</span>
        <span class="filter-action-button-count-badge" v-if="filters.items.length">
          {{filters.items.length}}
        </span>
      </fts-btn>
    </template>

    <template #menu>
      <div @click.stop>
        <draggable handle=".handle" draggable=".draggable-item" v-model="filters.items">
          <template v-for="(item, index) in filters.items">
            <div class="draggable-item">
              <fts-query :append-to-body="false" :information-source="columns" :filter="item" :states="states"
                :modules="modules" @remove="removeFilter(item)">
                <template #header>
                  <font-awesome-icon :icon="['fas', 'grip-vertical']" fixed-width
                    class="query-designer-handle handle" />
                </template>
                <template #suffix>
                  <fts-btn text icon class="clear-button" @click="removeFilter(item)">
                    <font-awesome-icon :icon="['far', 'trash-alt']" style="font-size: 0.775rem;" />
                  </fts-btn>
                </template>
                <template #dropdown-icon>
                  <font-awesome-icon :icon="['fas', 'chevron-down']" />
                </template>
              </fts-query>
            </div>
          </template>
        </draggable>
        <div class="divider" style="margin: 0px; margin-top: 4px;" />
        <fts-btn text text-transform-init class="action-button" @click="addFilter">
          <font-awesome-icon :icon="['fas', 'plus']" style="font-size: 0.775rem;" />
          Add filter
        </fts-btn>
        <fts-btn text text-transform-init class="action-button" @click="resetFilter">
          <font-awesome-icon :icon="['far', 'trash-alt']" style="font-size: 0.775rem;" />
          Clear all
        </fts-btn>
      </div>

    </template>
  </fts-dropdown-select>

</template>
<script>
import FTSBtn from '../elements/FTSBtn';
import FTSDropdownSelect from '../elements/FTSDropdownSelect';
import FTSLabelGroup from '../elements/FTSLabelGroup';
import commons from "../commons/commons";
import queryLogic from '../commons/queryLogic';
import FTSQuery from "../elements/FTSQuery";
import draggable from 'vuedraggable';

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-label-group": FTSLabelGroup,
    "fts-query": FTSQuery,
    draggable
  },
  data: () => ({
  }),
  props: {
    filters: Object,
    columns: Array,
    states: Array,
    modules: Array,
  },
  model: {
    prop: "filters"
  },
  methods: {
    onFilterModalShow() {
      if (this.filters && Array.isArray(this.filters.items) && this.filters.items.length === 0) {
        this.addFilter();
      }
    },
    addFilter() {
      this.filters.items.push({
        id: commons.nanoID(),
        ...queryLogic.prepareQueryUnit(
          this.columns,
          this.columns[0].id,
        ),
      }
      );
    },
    fieldItem(item) {
      if (this.columns) {
        return this.columns.find(x =>
          (item.fieldId && x.id === item.fieldId) ||
          (!item.fieldId && x.fieldName === item.fieldName)
        );
      }
    },
    resetFilter() {
      this.filters.items = [];
      this.$refs.filterDropdown.$refs.popper.doClose();
    },
    removeFilter(item) {

      if (!this.filters || !Array.isArray(this.filters.items)) return;


      const filterIndex =
        Array.isArray(this.filters.items) && this.filters.items.indexOf(item);
      if (filterIndex > -1) {
        this.filters.items.splice(filterIndex, 1);
      }

      if (this.filters.items.length === 0)
        this.$refs.filterDropdown.$refs.popper.doClose();
    },
  },
}
</script>
<style lang="scss">
.draggable-item {
  background-color: var(--fts-popover-alt-background);

  .handle {
    color: var(--fts-default);
  }
}

.filter-content {
  width: 600px;
  overflow: visible;
  // overflow-x: visible;
  // overflow-y: auto;

  .fts-date-time-range {
    display: flex;

  }

  .fts-query-wrapper {
    display: flex;
    flex-wrap: nowrap !important;
    gap: 8px;
    margin: 5px 4px;

    &:hover {
      border-color: transparent !important;
    }

    .query-designer-handle {
      visibility: visible !important;
    }
  }

  .query-dropdown-menu {
    width: 400px;
  }

  .fts-form-control,
  .query-dropdown,
  .vs-toggle {
    font-weight: 500;
    color: var(--inistate-text-primary-color);
    border: 1px solid var(--inistate-color-neutral-200);
    padding: 0px 0px;
    height: 45px;
    display: flex;
    padding: 0px 10px;

    // flex: 1 1 auto; // take all remaining space
    min-width: 0; // prevent overflow issues inside flex
    max-width: 100%; // limit to parent width
    max-height: 100%; // limit to parent width
    border-radius: 4px;
    align-items: center;
    flex: 1;
  }

  .fts-resize-none {
    padding: 11px 10px;
  }

  .fts-user,
  .fts-dropdown-user__select {
    width: 100% !important;

    .vs-selected-option {
      padding: 0px !important;
    }
  }

  .vue-daterange-picker,
  .query-search-form {
    display: flex !important;
    flex: 1;
  }

  .fts-form-control,
  .compact-form-design {
    display: flex !important;
    flex: 1 1 auto;
  }

  .fts-query .fts-query-wrapper .query-search-number .query-search-number__input {
    width: 100% !important
  }

  .query-search-form-wrapper {
    flex-wrap: nowrap !important;
    gap: 8px;
    flex: 1;
  }


  .information {
    flex-wrap: nowrap;
    flex: 1 1 auto;
    min-width: 30% !important;
    max-width: 30% !important;

    .query-dropdown-toggle-label {
      flex-wrap: nowrap !important;
    }
  }

  .operator {
    min-width: 15% !important;
    max-width: 20% !important;
    flex: 1 1 auto;
    // width: 100px !important;
  }

  .query-dropdown-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 0px 10px;
  }

  .dropdown-select-toggle {
    width: 100%;
  }

  .clear-button {
    padding: 0px !important;
    align-items: center;
    justify-content: center !important;
    border-radius: 99px !important;
    color: var(--fts-default) !important;
  }
}

.divider {
  background-color: var(--inistate-color-neutral-200);
}

.action-button {
  display: flex;
  width: 100%;
  justify-content: flex-start !important; // horizontal alignment
  align-items: start; // vertical alignment
  margin: 4px 0px;
  color: var(--inistate-text-primary-color) !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  border-radius: 0px !important;
  padding-left: 16px !important;
}

.dropdown-container {
  font-weight: 500;
  color: var(--inistate-text-primary-color);
  border: 1px solid var(--inistate-color-neutral-200);
  justify-content: space-between;
  padding: 8px 12px 8px 12px;
  width: 130px;
  display: flex;
}

.filter-item-handle {
  padding: 8px 0px 8px 0px;
  color: var(--fts-default);
}

.filter-item-wrapper {
  display: flex;
  gap: 10px;
  margin: 20px;
}

.filter-action-button {
  border: 1px solid var(--inistate-color-neutral-200) !important;
  color: var(--inistate-text-primary-color) !important;
  background-color: var(--inistate-color-shade-white) !important;

  .filter-action-button-icon {
    margin-right: 4px;
    font-weight: var(--inistate-font-weight-bold);
    font-size: 16px;
    color: var(--inistate-icon-primary);
  }

  .filter-action-button-count-badge {
    height: 16px;
    min-width: 16px;
    width: auto !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 6px;
    padding-left: 4px;
    padding-right: 4px;
    border-radius: var(--inistate-rounded-999);
    background-color: var(--inistate-color-primary-500);
    color: var(--inistate-color-shade-white);
    font-size: var(--inistate-paragraph-text-12);
    line-height: var(--inistate-paragraph-text-12--line-height);
    letter-spacing: normal;
  }

  &:hover {
    background-color: var(--inistate-color-neutral-50) !important;
  }

  &.filter-action-btn--active {
    background-color: var(--inistate-color-primary-50) !important;
    border: 1px solid var(--inistate-border-primary-active) !important;
    color: var(--inistate-color-primary-500) !important;

    .filter-action-button-icon {
      color: var(--inistate-icon-brand);
    }
  }
}
</style>
